export const REANALYSIS_WORKFLOW_ID = 'reanalysis';
